import React, { Component } from "react";
import Input from "../../Components/Inputs/Input/Input";
// import CarbonDropdown from "../../Components/Inputs/Dropdown/Dropdown";
// import Currency from "../../Components/Inputs/Currency/Currency";
// import DatePickerRange from '../../Components/DatePickers/DatePickerRange/DatePickerRange';
// import DatePickerSingle from "../../Components/DatePickers/DatePickerSingle/DatePickerSingle";
import ChangeEvents, { VALIDATION_ERROR_MESSAGE } from "./ChangeEvents";
import { fetchParentData } from "../../Flux/Actions/ParentActions";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import ParentDataStore from "../../Flux/Stores/ParentDataStore";
import SvgInfo from "../Partials/Icons/SvgInfo";
import Dropdown from "@acadia-ui/dropdown";
import { AccordionControl, AccordionContent } from "@acadia-ui/accordion";
import Textbox from "@acadia-ui/textbox";
import DatePicker from "@acadia-ui/datepicker";

import "./AdvertiserFormBuilder.scss";
import UpdateStateHelper from "./UpdateStateHelper";

const MissingData = () => (
	<div>No configuration found. Please visit the Client Configuration to manage this clients data keys. If you have any questions, please reach out to an administrator.</div>
);

class AdvertiserFormBuilder extends Component {
	constructor(props) {
		super(props);
		this.configName = this.props.configName;
		this.state = this.props.state;
		this.updateState = this.props.onUpdate;
		this.autoSelect = this.props.autoSelect;
		this.advertiser = this.props.advertiser;
		this.errors = this.props.errors;
	}

	componentDidMount = () => {};

	buildModalInputs = (data, state) => {
		const buildFormData = [];
		const objKeys = ["TaxonomyData", "ParentData"];
		// const objKeys = ["TaxonomyData", "ParentData", "MetaData"];
		// const objKeys = Object.keys(data);
		// Flatten items across categories to avoid splitting rows by category
		const items = [];
		for (const heading of objKeys) {
			const nodes = data?.[heading] || [];
			for (let i = 0; i < nodes.length; i++) {
				items.push({ el: nodes[i], heading });
			}
		}

		for (let i = 0; i < items.length; i += 2) {
			const firstItem = items[i];
			const secondItem = i + 1 < items.length ? items[i + 1] : null;

			const renderInput = (item) => {
				if (!item || !item.el) return null;
				const { el, heading } = item;
				if (el.FieldType !== "Hidden") {
					if (el.DataType === "String" || el.DataType === "Integer") return this.renderTextInput(el, heading, state);
					if (el.DataType === "Currency") return this.renderCurrencyInput(el, heading, state);
					if (el.DataType === "Date") return this.renderDateInput(el, heading, state);
					if (el.DataType === "Select") return this.renderSelectInput(el, heading, state);
				}
				return null;
			};

			const first = renderInput(firstItem);
			const second = renderInput(secondItem);

			buildFormData.push(
				<div className={"adConfigRow"} key={`row_${Math.floor(i / 2)}`}>
					{first}
					{second}
				</div>
			);
		}
		if (buildFormData.length < 1) {
			return <MissingData />;
		}
		return buildFormData;
	};

	// checkIfSingleOption = (el, heading, state) => {
	// 	if (el.Name !== "ParentDescription") {
	// 		if (el.Options.length === 1 && this.props.type && !this.props.type.includes("edit") && el.ParentName === null) {
	// 			const option = { value: el.Options[0].OptionID, label: el.Options[0].OptionLabel };
	// 			const name = el.Name;
	// 			const dataConfig = heading;
	// 			const id = el.ID;
	// 			const dataType = el.DataType;
	// 			if (!state.formData[el.Name]) {
	// 				ChangeEvents.handleAdvertiserSelectChange(option, name, dataConfig, id, dataType, this.updateState, this.props.advertiser);
	// 			}
	// 		}
	// 	}
	// 	return null;
	// };

	renderDateInput = (el, heading, state) => {
		const disabled = MasterCampaignsStore.getAdvertiserSuccess().includes(this.props.advertiser) || this.props.disableFields;
		const error = this.props.errors?.[this.props.advertiser]?.[el.Name];
		return (
			<>
				<DatePicker
					openOnClick
					className="adConfigDatepicker"
					disabled={disabled}
					value={state?.formData?.[el.Name]?.value ? new Date(state?.formData?.[el.Name]?.value) : ""}
					minDate={state?.metaData?.StartDate || null}
					maxDate={state?.metaData?.EndDate || null}
					error={error}
					forceInvalid={error}
					onChange={(date) => {
						// const [name, date, dataConfig, id, dataType] = args;
						const [name, dataConfig, id, dataType] = [el.Name, heading, el.ID, el.DataType];
						ChangeEvents.handleAdvertiserDateChange(name, date, dataConfig, id, dataType, this.updateState, this.props.advertiser);
					}}
				>
					<>
						{el.Label}
						{el.FieldDescription !== null && (
							<SvgInfo description={el.FieldDescription} style={{ enableBackground: "new 0 0 60 60", width: "20px", height: "20px" }} viewBox="-15 -7 30 15" />
						)}
					</>
				</DatePicker>
			</>
		);
	};

	renderSelectInput = (el, heading, state) => {
		const disabled = MasterCampaignsStore.getAdvertiserSuccess().includes(this.props.advertiser) || this.props.disableFields;
		const error = this.props.errors?.[this.props.advertiser]?.[el.Name];

		// prettier-ignore
		let data = (
            state?.formData?.[el.Name]?.value ? 
                this.returnDataValues(el, state).filter((option) => option.value !== state.formData[el.Name].value.value) : 
                this.returnDataValues(el, state)
        );

		// Removing duplicates from ParentData in Placement modal
		if (heading === "ParentData") {
			const removedDuplicates = [];
			const lookupObject = {};
			for (const i in data) {
				lookupObject[data[i].value] = data[i];
			}
			for (const i in lookupObject) {
				removedDuplicates.push(lookupObject[i]);
			}
			data = removedDuplicates;
		}

		let isDisabled = false;
		if (el.ParentName !== null) {
			let parentInConfig = false;
			const keys = Object.keys(this.props.data);
			keys.forEach((key) => {
				if (key !== "ChildData") {
					this.props.data[key].forEach((field) => {
						if (field.Name === el.ParentName) {
							parentInConfig = true;
						}
					});
				}
			});
			if (parentInConfig === true) {
				if (!state?.formData?.[el.ParentName]?.value) {
					isDisabled = true;
				}
			}
		} else if (el.ParentName === null) {
			if (state?.formData?.[el.Name]) {
				isDisabled = state.formData[el.Name].disabled;
			} else {
				isDisabled = false;
			}
		}

		return (
			<>
				<Dropdown
					// this comment exists to prevent eslint from making this unreadable.
					placeholder={`Select ${el.Label}`}
					className={"adConfigDropdown"}
					options={data}
					value={state?.formData?.[el.Name]?.value || ""}
					isDisabled={isDisabled || disabled}
					isClearable
					error={error}
					forceInvalid={error}
					onChange={(selectedOption) => {
						const [selectName, dataConfig, id, dataType] = [el.Name, heading, el.ID, el.DataType];
						ChangeEvents.handleAdvertiserSelectChange(selectedOption, selectName, dataConfig, id, dataType, this.updateState, this.props.advertiser);

						if (heading === "ParentData") {
							if (selectedOption) {
								if (selectedOption.value === "STANDALONE") {
									this.props.handleStandalone();
								} else {
									this.props.setLoading(() => {
										const filters = BookFiltersStore.getChoicesState();
										const campaignUniqueIdCode = MasterCampaignsStore.getParentCampaignUniqueID();
										fetchParentData(filters, campaignUniqueIdCode, selectedOption.value, this.props.auditLevelID);
									});
								}
							} else {
								ParentDataStore.resetParentData();
							}
						}
					}}
				>
					<>
						{el.Label}
						{el.FieldDescription !== null && (
							<SvgInfo description={el.FieldDescription} style={{ enableBackground: "new 0 0 60 60", width: "20px", height: "20px" }} viewBox="-15 -7 30 15" />
						)}
					</>
				</Dropdown>
			</>
		);
	};

	renderCurrencyInput = (el, heading, state) => {
		const disabled = MasterCampaignsStore.getAdvertiserSuccess().includes(this.props.advertiser) || this.props.disableFields;
		const error = this.props.errors?.[this.props.advertiser]?.[el.Name];
		return (
			<>
				<Textbox
					className={"adConfigTextbox"}
					type="currency"
					disabled={disabled}
					value={state?.formData?.[el.Name]?.value || 0}
					error={error}
					forceInvalid={error}
					onChange={(...args) => {
						if (el.FieldType !== "Calculated") {
							const [value, name, dataConfig, id, dataType] = args;
							ChangeEvents.handleAdvertiserCurrencyChange(value, name, dataConfig, id, dataType, this.updateState, this.props.advertiser);
						}
					}}
				>
					<>
						{el.Label}
						{el.FieldDescription !== null && (
							<SvgInfo description={el.FieldDescription} style={{ enableBackground: "new 0 0 60 60", width: "20px", height: "20px" }} viewBox="-15 -7 30 15" />
						)}
					</>
				</Textbox>
			</>
		);
	};

	renderTextInput = (el, heading, state) => {
		const disabled = MasterCampaignsStore.getAdvertiserSuccess().includes(this.props.advertiser) || this.props.disableFields;
		const type = el.DataType === "Integer" ? "number" : "text";
		const error = this.props.errors?.[this.props.advertiser]?.[el.Name];

		return (
			<>
				<Textbox
					className={"adConfigTextbox"}
					disabled={disabled}
					value={state?.formData?.[el.Name]?.value || ""}
					error={error || (el.ValidationString ? VALIDATION_ERROR_MESSAGE : undefined)}
					forceInvalid={error || undefined}
					pattern={el.ValidationString || undefined}
					onChange={(event) => {
						// adhere to the existing event structure expected in ChangeEvents
						const [selectName, dataConfig, id, dataType] = [el.Name, heading, el.ID, el.DataType];
						const evtObjt = { ...event, target: { ...event.target, name: selectName, dataset: { config: dataConfig }, id, dataType } };

						if (type === "text") {
							const validation = this.props.data.RegEx;
							if (heading === "TaxonomyData" || heading === "MetaData") {
								ChangeEvents.handleAdvertiserInputChange(evtObjt, this.updateState, "TaxOrMeta", validation, this.props.advertiser, el.ValidationString);
							} else {
								ChangeEvents.handleAdvertiserInputChange(evtObjt, this.updateState, type, validation, this.props.advertiser);
							}
						} else if (type === "number") {
							ChangeEvents.handleAdvertiserInputChange(evtObjt, this.updateState, type, this.props.advertiser);
						} else {
							ChangeEvents.handleAdvertiserInputChange(evtObjt, this.updateState, this.props.advertiser);
						}
					}}
				>
					<>
						{el.Label}
						{el.FieldDescription !== null && (
							<SvgInfo description={el.FieldDescription} style={{ enableBackground: "new 0 0 60 60", width: "20px", height: "20px" }} viewBox="-15 -7 30 15" />
						)}
					</>
				</Textbox>
			</>
		);
	};

	returnDataValues = (dataValueObject, state) => {
		if (dataValueObject.ParentName === null) {
			this.dataValues = dataValueObject.Options.map((el) => {
				return {
					value: el.OptionID,
					label: el.OptionLabel
				};
			});
			return this.dataValues;
		}
		let parentInConfig = false;
		const keys = Object.keys(this.props.data);
		keys.forEach((key) => {
			if (key !== "ChildData") {
				this.props.data[key].forEach((field) => {
					if (field.Name === dataValueObject.ParentName) {
						parentInConfig = true;
					}
				});
			}
		});
		if (parentInConfig === true || this.props.configName === "ActivationPlatform") {
			if (state?.formData?.[dataValueObject.ParentName]?.value) {
				const filteredOptions = dataValueObject.Options.filter((option) => {
					// condition #1 allows so called "orphaned" values to always be returned
					const c1 = !option.ParentOptionID;
					// condition #2 checks if the ParentOptionID matches the selected parent value exactly
					const c2 = option.ParentOptionID === state?.formData?.[dataValueObject.ParentName]?.value?.value;
					// condition #3 checks if the ParentOptionID is a CSV list and if so, splits it and checks if any match the selected parent value
					const c3 =
						option.ParentOptionID &&
						option.ParentOptionID.includes(",") &&
						option.ParentOptionID.split(",").includes(state?.formData?.[dataValueObject.ParentName]?.value?.value);

					// return true if any condition is met
					return c1 || c2 || c3 || false;
				});
				if (filteredOptions.length > 0) {
					this.dataValues = filteredOptions.map((el) => {
						return {
							value: el.OptionID,
							label: el.OptionLabel,
							parentName: dataValueObject.ParentName
						};
					});
					return this.dataValues;
				}
				this.dataValues = dataValueObject.Options.map((el) => {
					return {
						value: el.OptionID,
						label: el.OptionLabel,
						parentName: dataValueObject.ParentName
					};
				});
				return this.dataValues;
			}
			this.dataValues = dataValueObject.Options.map((el) => {
				return {
					value: el.OptionID,
					label: el.OptionLabel
				};
			});
			return this.dataValues;
		}
		if (parentInConfig === false && this.props.configName !== "ActivationPlatform") {
			let config = MasterCampaignsStore.getActivationConfig();
			const selectedCampaign = UpdateStateHelper.matchParentCampaign();
			if (selectedCampaign !== null && selectedCampaign !== undefined) {
				const campaignKeys = Object.keys(selectedCampaign);
				let parentValue = null;
				let selectedOptionID;
				campaignKeys.forEach((key) => {
					if (key === dataValueObject.ParentName) {
						parentValue = selectedCampaign[key];
					}
				});
				const configKeys = Object.keys(config);
				configKeys.forEach((key) => {
					config[key].forEach((field) => {
						if (field.Name === dataValueObject.ParentName) {
							field.Options.forEach((option) => {
								if (option.OptionLabel === parentValue) {
									selectedOptionID = option.OptionID;
								}
							});
						}
					});
				});
				const filteredOptions = dataValueObject.Options.filter((option) => {
					return option.ParentOptionID === selectedOptionID;
				});
				if (filteredOptions.length > 0) {
					this.dataValues = filteredOptions.map((el) => {
						return {
							value: el.OptionID,
							label: el.OptionLabel,
							parentName: dataValueObject.ParentName
						};
					});
					return this.dataValues;
				}
				this.dataValues = dataValueObject.Options.map((el) => {
					return {
						value: el.OptionID,
						label: el.OptionLabel,
						parentName: dataValueObject.ParentName
					};
				});
				return this.dataValues;
			}
			this.dataValues = dataValueObject.Options.map((el) => {
				return {
					value: el.OptionID,
					label: el.OptionLabel,
					parentName: dataValueObject.ParentName
				};
			});
			return this.dataValues;
		}
	};

	render() {
		if (this.props.data) {
			return (
				<>
					<AccordionControl
						// this comment exists to prevent eslint from making this unreadable.
						targetId={this.props.type}
						groupName={"advertiserFormBuilder"}
						// {...(this.props.errors?.[this.props.advertiser] ? { isOpen: true } : {})}
						allowMultipleOpen={true}
						className={"advertiserAccordionControl"}
					>
						<div>{this.props.advertiser}</div>
						<div>Advertiser Taxonomy</div>
						<div>(Optional)</div>
						{this.props.errors?.[this.props.advertiser] && <i className="icon-warning" />}
					</AccordionControl>
					<AccordionContent
						// this comment exists to prevent eslint from making this unreadable.
						id={this.props.type}
						groupName={"advertiserFormBuilder"}
					>
						<div className={"adConfigContainer"}>{this.buildModalInputs(this.props.data, this.props.state)}</div>
					</AccordionContent>
				</>
			);
		}
		return null;
	}
}

export default AdvertiserFormBuilder;
